import { render } from "./pb-pagecontacttitle.vue?vue&type=template&id=581206f8"
import script from "./pb-pagecontacttitle.vue?vue&type=script&lang=js"
export * from "./pb-pagecontacttitle.vue?vue&type=script&lang=js"

import "./pb-pagecontacttitle.vue?vue&type=style&index=0&id=581206f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__